import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_14, FONT_PROXIMA_11, FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {GRAY_DARKER} from 'ui-library/Colors';

const QUALITY_GRADIENTS: Array<{color: string; text: string}> = [
  {color: '#3557CA', text: 'Very high (pLDDT > 90)'},
  {color: '#99C7ED', text: 'Confident (90 > pLDDT > 70)'},
  {color: '#F2DC5B', text: 'Low (70 > pLDDT > 50)'},
  {color: '#D68A59', text: 'Very low (pLDDT < 50)'},
];

export default function QualityDataLegend(): JSX.Element {
  return (
    <>
      <p className={css(styles.title)}>Model confidence</p>
      <p className={css(styles.plddtDescription)}>
        AlphaFold produces a per-residue confidence score (pLDDT) between 0 and 100. Some regions below 50
        pLDDT may be unstructured in isolation.
      </p>
      {QUALITY_GRADIENTS.map(({color, text}, i) => (
        <div key={i}>
          <div className={css(styles.colorSwatch)} style={{backgroundColor: color}} />
          <span className={css(styles.qualityDescription)}>{text}</span>
        </div>
      ))}
    </>
  );
}

const styles = StyleSheet.create({
  title: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  plddtDescription: {
    ...FONT_PROXIMA_11,
    color: GRAY_DARKER,
  },
  qualityDescription: {
    verticalAlign: 'middle',
  },
  colorSwatch: {
    width: '14px',
    height: '14px',
    display: 'inline-block',
    marginRight: '8px',
    verticalAlign: 'middle',
  },
});
